import { Text, View } from 'react-native';
import TextLato from '../../../text/text-lato/TextLato';
import { style } from './ModalUpSelling.styles';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { useStore } from 'src/contexts/StoreContext';
import Video from '@photosi/rn-components/video/Video';
import { TestIDs } from 'src/constants/testIDs.constants';
import BaseModal from '../../base-modal/BaseModal';
import { getFormattedPrice } from 'src/helpers/price.helper';
import { DynamicModalProps } from '../DynamicModal.types';

export const ModalUpSelling = ({
  type,
  dynamicModalVisible,
  dynamicModalLayer: { onPressDiscardChanges, onPressSaveChanges, upSellingModalData, id },
}: DynamicModalProps) => {
  const upsellingData = upSellingModalData.upsellingData[0];

  const {
    project: { activeProduct },
  } = useStore();

  const handleDiscadButton = async () => {
    onPressDiscardChanges();
    amplitude.trackEvent(AnalyticsEvents.upselling.declined);
  };
  const handleConfirmButton = async () => {
    onPressSaveChanges();

    amplitude.trackEvent(AnalyticsEvents.upselling.accepted, {
      current_product_id: activeProduct!.id,
      new_product_id: upsellingData.upsellingProductId,
      proposed_price: upsellingData.prices.upsellingPublicUnitPrice,
      title: upsellingData.eventCode,
    });
  };

  return (
    <BaseModal
      testID={TestIDs.UPSELLING}
      closeOnClickOutside={false}
      modalIcon={null}
      header={
        <View style={style.titleContainer}>
          <TextLato style={style.title}>{upsellingData.header}</TextLato>
          <Text>{'+' + getFormattedPrice({ price: upsellingData.prices.difference })}</Text>
        </View>
      }
      body={
        <>
          <Text style={style.description}>{upsellingData.description}</Text>
          <View style={style.videoContainer}>
            <Video
              source={{
                uri: upsellingData.galleryItems[0].value.url,
              }}
              repeat={upsellingData.galleryItems[0].value.loop}
            />
          </View>
        </>
      }
      discardText={upsellingData.denyCta}
      confirmText={upsellingData.confirmCta}
      handleDiscard={handleDiscadButton}
      handleConfirm={handleConfirmButton}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
    />
  );
};
